import AppConfig from '@/AppConfig';

const initMobileEvents = () => {
  window.onMobileBackPress = onMobileBackPress;
};

const onMobileBackPress = () => {
  window.dev.i('onMobileBackPress: Back pressed');
  window.dispatchEvent(new CustomEvent(AppConfig.MOBILE_BACK_PRESS_EVENT));
};

export default initMobileEvents;
